import React, { useEffect, useState } from 'react';
import DialogContent from '@mui/material/DialogContent';
import ButtonRound from '../../ButtonRound';
import TextField from '@mui/material/TextField';
import styles from './Modal.scss';
import Select from '../../MaterialUi/Select';
import Config from '../../../utils/Config';
import UserRequest from '../../../utils/UserRequest';

const userApiUrl = Config.get('userApi.url');

const PhoneNumber = ({ nextStep, prevStep, values, setSalt, setCode, handlePhoneNumberChange }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [errorList, setErrorList] = useState([]);


    const goToNextStep = e => {
        e.preventDefault();
        nextStep();
    }

    const goToPrevStep = e => {
        e.preventDefault();
        prevStep();
    }

    const handleSendVerificationCode = (ev: React.FormEvent) => {
        //form validation
        const errorList = validateForm();
        if (errorList.length > 0) {
            setErrorList(errorList);
            return;
        }

        ev.preventDefault();
        setIsLoading(true);
        return UserRequest.postRequest(userApiUrl + '/user-api/user/doi?_format=json', {
            method: 'sms',
            action: 'send',
            phone: values.prefix + values.phone
        }, { timeout: 60000 })
            .then((res) => {
                // success
                setIsLoading(false);
                const data = res.getData();
                setSalt(data.data.salt);
                setCode('');
                goToNextStep(ev);
            })
            .catch((e) => {
                // reset state on error
                setIsLoading(false);
                const errorList = [];
                errorList.push({ id: 'phone', text: 'Die SMS konnte nicht gesendet werden.', fields: ['phone'] });
                setErrorList(errorList);
                return Promise.reject(e);
            });
    };

    const validateForm = () => {
        const errorList = [];
        const regex = new RegExp(/(^\d*$)|(Backspace|Tab|Delete|ArrowLeft|ArrowRight)/);

        if (values.phone == '') {
            errorList.push({ id: 'phone', text: 'Bitte gib deine Mobilfunknummer an.', fields: ['phone'] });
        } else if ((values.phone).startsWith("0")) {
            errorList.push({ id: 'phone', text: 'Bitte gib eine gültige Mobilfunknummer ohne führende 0 an.', fields: ['phone'] });
        }
        else if (!(values.phone).startsWith("1")) {
            errorList.push({ id: 'phone', text: 'Bitte gib eine gültige Mobilfunknummer an.', fields: ['phone'] });
        } else if (!values.phone.match(regex)) {
            errorList.push({ id: 'phone', text: 'Die Mobilfunknummer darf ausschließlich aus Zahlen bestehen.', fields: ['phone'] });
        }

        return errorList;
    };

    return (
        <div>
            <DialogContent dividers={false}>
                <p>Im Anschluss wird an diese Mobilfunknummer eine SMS mit einem Verifizierungscode gesendet.</p>
                <div className={styles.phoneNumber}>
                    <div>
                        <Select onChange={null} name="prefix" value={values.prefix} label="Vorwahl" disabled>
                            <option value="+49">Deutschland +49 (0)</option>
                        </Select>
                        <TextField
                            name="phoneNumber"
                            //defaultValue={defaultPhoneNumber}
                            value={values.phone}
                            onChange={handlePhoneNumberChange}
                            label="Telefonnummer"
                            required
                            inputMode="numeric"
                            type="number"
                        />
                    </div>
                    {errorList
                        .filter((e) => e.id === 'phone')
                        .map((e) => (
                            <p className={styles.error} key={e.text}>
                                {e.text}
                            </p>
                        ))}
                </div>
                <p>Wir geben deine Mobilfunknummer nicht weiter und veröffentlichen diese nicht.</p>
                <div className={styles.phoneNumberButtons}>
                    <ButtonRound type="submit" variant="outlined" className={'button button--secondary'} isLoading={false} onClick={goToPrevStep}>
                        Zurück
                    </ButtonRound>
                    <ButtonRound type="submit" className={'button button--primary'} isLoading={isLoading} onClick={handleSendVerificationCode}>
                        Weiter
                    </ButtonRound>
                </div>
            </DialogContent>
        </div>
    )
}

export default PhoneNumber